import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "check-the-commerce-version"
    }}>{`Check the Commerce version`}</h1>
    <p>{`Use any of the following ways to determine which version of Adobe Commerce or Magento Open Source is installed:`}</p>
    <ul>
      <li parentName="ul">{`From the command line`}</li>
      <li parentName="ul">{`With an HTTP GET request`}</li>
      <li parentName="ul">{`From within the Admin`}</li>
      <li parentName="ul">{`By viewing the `}<inlineCode parentName="li">{`composer.lock`}</inlineCode>{` file`}</li>
    </ul>
    <h2 {...{
      "id": "command-line"
    }}>{`Command line`}</h2>
    <p>{`The following command returns the application version.`}</p>
    <p><strong parentName="p">{`Command:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`bin/magento --version
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-terminal"
      }}>{`Magento CLI version 2.4.0
`}</code></pre>
    <h2 {...{
      "id": "http-get-request"
    }}>{`HTTP GET request`}</h2>
    <p>{`An HTTP request returns less detailed information about the application version.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`http://<magento2-store>/magento_version
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`Magento/2.3 (Community)
`}</code></pre>
    <h2 {...{
      "id": "admin"
    }}>{`Admin`}</h2>
    <p>{`Log in as a registered Admin user. The application version is displayed at the bottom right of the page, above the  `}<strong parentName="p">{`Account Activity`}</strong>{` and `}<strong parentName="p">{`Report an Issue`}</strong>{` links:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "9.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/5530d/version.webp 320w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/0c8fb/version.webp 640w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/94b1e/version.webp 1280w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/0b34d/version.webp 1920w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/d5269/version.webp 2560w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/d91cc/version.webp 3170w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/dd4a7/version.png 320w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/0f09e/version.png 640w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/bbbf7/version.png 1280w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/ac7a9/version.png 1920w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/c7a69/version.png 2560w", "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/a0c96/version.png 3170w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/commerce/php/static/23a06c0f2b6cdd44e2c66b1de6b8c67b/bbbf7/version.png",
            "alt": "Check the application version",
            "title": "Check the application version",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "the-composerlock-file"
    }}>{`The `}<inlineCode parentName="h2">{`composer.lock`}</inlineCode>{` file`}</h2>
    <p>{`If the application was installed using the `}<inlineCode parentName="p">{`composer install`}</inlineCode>{` command, you can search the `}<inlineCode parentName="p">{`<Application_root>/composer.lock`}</inlineCode>{` file for `}<inlineCode parentName="p">{`magento/product-community-edition`}</inlineCode>{` or `}<inlineCode parentName="p">{`magento/product-enterprise-edition`}</inlineCode>{`, depending on which version of the application is installed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`  {
    "name": "magento/product-community-edition",
    "version": "2.4.0",
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      